import { metaMaskWallet, okxWallet, walletConnectWallet } from "@rainbow-me/rainbowkit/wallets";
import { createConfig } from "wagmi";
import { defineChain } from 'viem';
import { connectorsForWallets } from "@rainbow-me/rainbowkit";
import { http } from "wagmi";
import { mainnet, bsc, polygon, sepolia, bscTestnet, polygonAmoy } from "viem/chains";
import ETHIcon from "../../assets/image/chainIcons/eth@2x.png";
import BSCIcon from "../../assets/image/chainIcons/BNB@2x.png";
import PolygonIcon from "../../assets/image/chainIcons/Polygon@2x.png";
import NetXIcon from "../../assets/image/chainIcons/NetX@2x.png";
import ETHScanIcon from "../../assets/image/chainIcons/EtherScan@2x.png";
import BSCScanIcon from "../../assets/image/chainIcons/BscScan@2x.png";
import PolygonScanIcon from "../../assets/image/chainIcons/PolygonScan@2x.png";
import NetXScanIcon from "../../assets/image/chainIcons/NetXScan@2x.png";
// main network
export const ETHMain = defineChain({
    ...mainnet,
    icon: ETHIcon,
    scanLogo: ETHScanIcon,
    rpcUrls: {
        default: { http: ['https://eth-mainnet.nodereal.io/v1/134d665b67af47ddbc35a182caf6c16e'] },
    },
});
export const BSCMain = defineChain({
    ...bsc,
    icon: BSCIcon,
    scanLogo: BSCScanIcon,
    rpcUrls: {
        default: { http: ['https://bsc-mainnet.nodereal.io/v1/134d665b67af47ddbc35a182caf6c16e'] },
    },
});
export const PolygonMain = defineChain({
    ...polygon,
    icon: PolygonIcon,
    scanLogo: PolygonScanIcon,
    rpcUrls: {
        default: { http: ['https://polygon-bor-rpc.publicnode.com'] },
    },
});
export const TSCMain = defineChain({
    id: 287,
    name: 'NetX Mainnet',
    icon: NetXIcon,
    scanLogo: NetXScanIcon,
    iconUrl: NetXIcon,
    nativeCurrency: {
        decimals: 18,
        name: 'NETX',
        symbol: 'NETX',
    },
    rpcUrls: {
        default: { http: ['https://rpc.netxscan.io'] },
    },
    blockExplorers: {
        default: {
            name: 'NetXScan',
            url: 'https://netxscan.io'
        },
    }
});
// test network
export const ETHTestSepolia = defineChain({
    ...sepolia,
    icon: ETHIcon,
    scanLogo: ETHScanIcon,
    rpcUrls: {
        default: { http: ['https://ethereum-sepolia-rpc.publicnode.com', 'wss://ethereum-sepolia-rpc.publicnode.com'] },
    },
});
export const BSCTest = defineChain({
    ...bscTestnet,
    icon: BSCIcon,
    scanLogo: BSCScanIcon
});
export const PolygonTestAmoy = defineChain({
    ...polygonAmoy,
    icon: PolygonIcon,
    iconUrl: PolygonIcon,
    scanLogo: PolygonScanIcon
});
export const TSCTest = defineChain({
    id: 587,
    name: 'NetX Testnet',
    icon: NetXIcon,
    scanLogo: NetXScanIcon,
    iconUrl: NetXIcon,
    nativeCurrency: {
        decimals: 18,
        name: 'tNETX',
        symbol: 'tNETX',
    },
    rpcUrls: {
        default: { http: ['https://testnetrpc.netxscan.io'] },
    },
    blockExplorers: {
        default: {
            name: 'NetXScan',
            url: 'https://testnet.netxscan.io'
        },
    }
});
export const TSCPre = TSCMain;
// chainlist
const MainNetWork = [
    BSCMain, ETHMain, PolygonMain, TSCMain
];
const TestNetWork = [
    BSCTest, ETHTestSepolia, PolygonTestAmoy, TSCTest
];
// MetaMask 钱包配置 - 确保正确处理多个 ethereum 提供者
const connectors = connectorsForWallets([
    {
        groupName: 'Recommended',
        wallets: [metaMaskWallet, okxWallet, walletConnectWallet],
    },
], {
    appName: 'NetX',
    projectId: 'edf45e86a100cf6c894c3845ac9a2e3f',
});
// 确保 activeChain 始终是数组
const activeChain = MainNetWork;
export const walletConfig = createConfig({
    connectors,
    chains: activeChain, // 类型断言：运行时这些链都是有效的数组
    transports: activeChain.reduce((acc, chain) => {
        acc[chain.id] = http();
        return acc;
    }, {}),
    ssr: true,
});
